import { LanguagesEnum } from '@/api/enums';
import { Slide, SlideTemplateType } from '@/client/courses/types/courses.type';
import { ChapterForm } from '@/components/slides/admin/slide-templates/ChapterForm';
import { GalleryForm } from '@/components/slides/admin/slide-templates/GalleryForm';
import { TextImageForm } from '@/components/slides/admin/slide-templates/TextImageForm';
import { SlideEditorQuillToolbar } from '@/components/slides/admin/SlideEditorQuillToolbar';
import { ProgressHeader } from '@/ui/progress-header/ProgressHeader';
import React from 'react';
import 'react-quill/dist/quill.snow.css';

interface SlideTemplateProps {
  currentEditingSlide: Slide;
  currentSlideData: Slide;
  selectedLanguage: string;
  isEditingPopUpSlide: boolean;
  currentSlideIdx: number;
  slides: Slide[];
  totalSlides: number;
  updateSlide: (id: string, updates: Partial<Slide>) => void;
}

export const SlideTemplate: React.FC<SlideTemplateProps> = ({
  currentEditingSlide,
  updateSlide,
  selectedLanguage,
  isEditingPopUpSlide,
  currentSlideIdx,
  slides,
  currentSlideData,
  totalSlides,
}) => {
  return (
    <>
      <SlideEditorQuillToolbar
        key={`${selectedLanguage}-${
          currentEditingSlide?.id
        }-${currentSlideIdx}-${isEditingPopUpSlide ? 'popup' : 'main'}`}
      />

      {!isEditingPopUpSlide && (
        <ProgressHeader
          currentIndex={currentSlideIdx}
          totalCount={totalSlides}
          type="slide"
          attemptLanguage={selectedLanguage as LanguagesEnum}
        />
      )}
      {[SlideTemplateType.TEXT_IMAGE, SlideTemplateType.SUMMARY].includes(
        currentSlideData.templateType,
      ) && (
        <TextImageForm
          currentEditingSlide={currentEditingSlide}
          updateSlide={updateSlide}
          selectedLanguage={selectedLanguage}
          isEditingPopUpSlide={isEditingPopUpSlide}
          currentSlideIdx={currentSlideIdx}
          slides={slides}
          currentSlideData={currentSlideData}
          totalSlides={totalSlides}
          isSummary={
            currentSlideData.templateType === SlideTemplateType.SUMMARY
          }
        />
      )}
      {currentSlideData.templateType === SlideTemplateType.CHAPTER && (
        <ChapterForm
          currentEditingSlide={currentEditingSlide}
          updateSlide={updateSlide}
          selectedLanguage={selectedLanguage}
          isEditingPopUpSlide={isEditingPopUpSlide}
          currentSlideIdx={currentSlideIdx}
          totalSlides={totalSlides}
          currentSlideData={currentSlideData}
        />
      )}
      {currentSlideData.templateType === SlideTemplateType.GALLERY && (
        <GalleryForm
          currentEditingSlide={currentEditingSlide}
          updateSlide={updateSlide}
          selectedLanguage={selectedLanguage}
          isEditingPopUpSlide={isEditingPopUpSlide}
          currentSlideIdx={currentSlideIdx}
          totalSlides={totalSlides}
          currentSlideData={currentSlideData}
        />
      )}
    </>
  );
};
